import { combineReducers } from 'redux';

import types from './types';

import InvoiceModel from 'src/model/invoice.model';
import DateRangeModel from 'src/model/dateRange.model';
import {
  sortType,
  statusType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';

const data = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_INVOICES_DATA:
      return payload;
    default:
      return state;
  }
};

const originalInvoicedata = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_ORIGINAL_INVOICES:
      return payload;
    default:
      return state;
  }
};
const oldestInvoicedata = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_OLDEST_INVOICES:
      return payload;
    default:
      return state;
  }
};

const creditTotalElements = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDIT_INVOICES_TOTAL_ELEMENTS:
      return payload;
    default:
      return state;
  }
};

const selectcreditInvoicedata = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_CREDIT_INVOICES:
      return payload;
    default:
      return state;
  }
};
const totalCreditmanual = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDIT_INVOICES_CREDIT:
      return payload;

    default:
      return state;
  }
};
const totalDebitmanual = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CREDIT_INVOICES_DEBIT:
      return payload;

    default:
      return state;
  }
};

const datesFilter = (
  state: DateRangeModel = null,
  { type, payload }: { type: string; payload: DateRangeModel }
) => {
  switch (type) {
    case types.SET_INVOICES_DATE_RANGE_FILTER:
      return payload;

    default:
      return state;
  }
};

const sortFilter = (
  state: { type: sortType; order: 'asc' | 'desc' } = null,
  {
    type,
    payload
  }: { type: string; payload: { type: sortType; order: 'asc' | 'desc' } }
) => {
  switch (type) {
    case types.SET_INVOICES_SORT_FILTER:
      return payload;

    default:
      return state;
  }
};

const statusFilter = (
  state: statusType = null,
  { type, payload }: { type: string; payload: statusType }
) => {
  switch (type) {
    case types.SET_INVOICES_STATUS_FILTER:
      return payload;

    default:
      return state;
  }
};

const orderFilter = (
  state: orderType = null,
  { type, payload }: { type: string; payload: orderType }
) => {
  switch (type) {
    case types.SET_INVOICES_ORDER_STATUS_FILTER:
      return payload;

    default:
      return state;
  }
};
const invoiceFilter = (
  state: invoiceType = null,
  { type, payload }: { type: string; payload: invoiceType }
) => {
  switch (type) {
    case types.SET_INVOICES_INVOICE_FILTER:
      return payload;

    default:
      return state;
  }
};
const nardFilter = (
  state: nardType = null,
  { type, payload }: { type: string; payload: nardType }
) => {
  switch (type) {
    case types.SET_INVOICES_NARD_FILTER:
      return payload;

    default:
      return state;
  }
};

const orderNumberFilter = (
  state: ordernumberType = null,
  { type, payload }: { type: string; payload: ordernumberType }
) => {
  switch (type) {
    case types.SET_INVOICES_ORDER_FILTER:
      return payload;

    default:
      return state;
  }
};
const poNumberFilter = (
  state: poType = null,
  { type, payload }: { type: string; payload: poType }
) => {
  switch (type) {
    case types.SET_INVOICES_PO_FILTER:
      return payload;

    default:
      return state;
  }
};

const pageNumber = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_INVOICES_PAGE_NUMBER:
      return payload;

    default:
      return state;
  }
};

const totalCredit = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_OLDEST_INVOICES_CREDIT:
      return payload;
    case types.SET_ORIGINAL_INVOICES_CREDIT:
      return payload;
    case types.SET_INVOICES_CREDIT:
      return payload;
    default:
      return state;
  }
};

const totalDebit = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_OLDEST_INVOICES_DEBIT:
      return payload;
    case types.SET_ORIGINAL_INVOICES_DEBIT:
      return payload;
    case types.SET_INVOICES_DEBIT:
      return payload;
    default:
      return state;
  }
};
const totalCreditoriginal = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_ORIGINAL_INVOICES_CREDIT:
      return payload;

    default:
      return state;
  }
};

const totalDebitoriginal = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_ORIGINAL_INVOICES_DEBIT:
      return payload;

    default:
      return state;
  }
};

const pageSize = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_INVOICES_PAGE_SIZE:
      return payload;

    default:
      return state;
  }
};
const totalElements = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_INVOICES_TOTAL_ELEMENTS:
      return payload;
    default:
      return state;
  }
};
const totalPages = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_INVOICES_TOTAL_PAGES:
      return payload;

    default:
      return state;
  }
};

const getInvoicesIsPending = (
  state: boolean = false,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_INVOICES_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: { caller: string; hasFailed: boolean; message: string } = {
    caller: '',
    hasFailed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_INVOICES_ERROR:
      return payload;

    default:
      return state;
  }
};

const success = (
  state: { hasSucceed: boolean; message: string } = {
    hasSucceed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_INVOICES_SUCCESS:
      return payload;

    default:
      return state;
  }
};
const manualerror = (
  state: { caller: string; hasFailed: boolean; message: string } = {
    caller: '',
    hasFailed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_MANUAL_INVOICES_ERROR:
      return payload;

    default:
      return state;
  }
};
const manualsuccess = (
  state: { hasSucceed: boolean; message: string } = {
    hasSucceed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_MANUAL_INVOICES_SUCCESS:
      return payload;

    default:
      return state;
  }
};
const selectedInvoices = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_SELECTED_INVOICES:
      return payload;

    default:
      return state;
  }
};

const selectedCreditInvoices = (
  state: InvoiceModel[] = [],
  { type, payload }: { type: string; payload: InvoiceModel[] }
) => {
  switch (type) {
    case types.SET_SELECTED_CREDIT_INVOICES:
      return payload;

    default:
      return state;
  }
};

const isInvoiceActive = (
  state: string[] = [],
  { type, payload }: { type: string; payload: string[] }
) => {
  switch (type) {
    case types.SET_IS_INVOICE_ACTIVE:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  originalInvoicedata,
  oldestInvoicedata,
  datesFilter,
  sortFilter,
  statusFilter,
  orderFilter,
  invoiceFilter,
  nardFilter,
  orderNumberFilter,
  poNumberFilter,
  pageNumber,
  pageSize,
  totalElements,
  creditTotalElements,
  totalPages,
  getInvoicesIsPending,
  error,
  success,
  selectedInvoices,
  isInvoiceActive,
  totalCredit,
  totalDebit,
  totalCreditoriginal,
  totalDebitoriginal,
  selectcreditInvoicedata,
  selectedCreditInvoices,
  totalCreditmanual,
  manualerror,
  manualsuccess,
  totalDebitmanual
});
